import React, { useEffect, useState } from "react";
import "./AboutUs.css";

// Import images
import img1 from "../assets/1.jpg";
import visionMissionImg from "../assets/2.jpg";
import chooseUs from "../assets/3.jpg";
import img4 from "../assets/4.jpg";
import img5 from "../assets/5.jpg";
import img6 from "../assets/6.jpg";
import img7 from "../assets/7.jpg";
import img8 from "../assets/8.jpg";
import img9 from "../assets/9.jpg";
import img10 from "../assets/10.jpg";

const images = [img1, img4, img5, img6, img7, img8, img9, img10];

const AboutUs = () => {
  const [currentImage, setCurrentImage] = useState(0);

  // Auto slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Intersection Observer for animations
  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );
    sections.forEach((sec) => observer.observe(sec));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-page">
          
      {/* Slideshow */}
      {/* Fullscreen Slideshow with Hero Overlay */}
      <div className="slideshow-container">
        {images.map((img, i) => (
          <div
            key={i}
            className={`slide-wrapper ${i === currentImage ? "active" : ""}`}
          >
            <img
              src={img}
              alt={`Slide ${i}`}
              className="slide-image"
            />
          </div>
        ))}
      </div>
      <button onClick={() => setCurrentImage((currentImage - 1 + images.length) % images.length)}>‹</button>
      <button onClick={() => setCurrentImage((currentImage + 1) % images.length)}>›</button>
      <div className="dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === currentImage ? "active" : ""}`}
            onClick={() => setCurrentImage(i)}
          />
        ))}
      </div>
      {/* --- Main Content --- */}
      <div className="about-container">
        {/* Intro */}
        <div className="about-intro fade-in">
          <h2>Who We Are</h2>
          <p>
            <strong>Bengaluru</strong> is India’s thriving hub for innovation — home to
            global corporations, tech giants, and a vibrant startup ecosystem. With
            continuous infrastructure advancements such as the{" "}
            <strong>Bengaluru Metro Rail</strong> and{" "}
            <strong>Peripheral Ring Road</strong>, the city’s commercial property sector
            continues to attract global attention.
          </p>
          <p>
            At <strong>VentureStones Realty</strong>, we empower investors, developers,
            and enterprises to make informed real estate decisions. Our expert consultants
            provide tailored solutions across{" "}
            <strong>Office, Industrial, Retail, and Data Centre</strong> sectors — backed
            by local insight and a global network.
          </p>
        </div>
        <div className="about-vision fade-in">
          <img
            src={visionMissionImg}
            alt="Vision and Mission"
            className="vision-image"
          />
        </div>
        <div className="about-vision fade-in">
          <img
            src={chooseUs}
            alt="Vision and Mission"
            className="vision-image"
          />
        </div>
        {/* Value Cards */}
        <div className="about-values fade-in">
          <div className="cards">
            <div className="card">
              <div className="icon">🌍</div>
              <h4>Local Expertise, Global Reach</h4>
              <p>
                Combining Bengaluru market expertise with{" "}
                <strong>VentureStone’s 400 global offices</strong>, we deliver actionable,
                data-driven insights that drive growth and value.
              </p>
            </div>
            <div className="card">
              <div className="icon">🤝</div>
              <h4>Client-Centric Approach</h4>
              <p>
                We build relationships based on trust. From acquisitions to asset
                management, every service is tailored to meet your business goals.
              </p>
            </div>
            <div className="card">
              <div className="icon">🏆</div>
              <h4>Proven Excellence</h4>
              <p>
                With a legacy of success in high-value developments,{" "}
                <strong>VentureStones Realty</strong> stands as a benchmark in
                Bengaluru’s competitive property market.
              </p>
            </div>
          </div>
        </div>

        {/* Beyond Bengaluru */}
        <div className="about-beyond fade-in">
          <h2>Thinking Beyond Bengaluru?</h2>
          <p>
            Whether expanding nationwide or exploring international opportunities, our
            global reach ensures your portfolio thrives wherever your vision takes you.
            Connect with our experts across <strong>100+ cities</strong> and unlock
            unparalleled investment insights.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
